module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "LitecoinLogo.f8fad246.svg";